module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("Mountain of Light")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I do not write this to complain; I have written the plain truth. I do not write to praise myself but to set down exactly what happened. In this history I have been determined to write truthfully about everything. As a consequence I have set down all that is good or bad I have seen of father, kinsman or stranger. Reader, pardon this . . .")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("Diary of Babur, Founder of the Moghul Empire")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdb3e4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter03.vue
// module id = 72
// module chunks = 0